var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93783 0C5.07091 0.016988 5.20463 0.029916 5.33685 0.0516051C7.07039 0.335593 8.30112 1.28916 9.00796 2.89234C9.46846 3.93694 9.48007 5.02236 9.15862 6.11568C8.89236 7.02117 8.48652 7.86416 8.01973 8.6782C7.17843 10.1453 6.16984 11.493 5.06995 12.7735C4.81072 13.0753 4.55831 13.0757 4.29961 12.7734C3.05321 11.3165 1.91538 9.78231 1.02283 8.07763C0.614751 7.29811 0.255791 6.49454 0.0943712 5.62281C-0.222822 3.91012 0.261652 2.44616 1.51647 1.24846C2.2574 0.541265 3.15699 0.154708 4.16972 0.0288475C4.25688 0.0180564 4.34436 0.00961585 4.43162 0C4.60039 0 4.76916 0 4.93783 0ZM4.66975 7.07577C5.94769 7.09885 7.01839 6.04367 7.04236 4.73762C7.06623 3.43564 6.02014 2.36123 4.70609 2.33804C3.4241 2.31539 2.35489 3.36352 2.3274 4.66967C2.29991 5.97668 3.34653 7.05184 4.66975 7.07577Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b71fab7d66149eb549c65c869015f5dd.svg";
export { ForwardRef as ReactComponent };